import { render, staticRenderFns } from "./ProductStatus.vue?vue&type=template&id=77ee2266&"
import script from "./ProductStatus.vue?vue&type=script&lang=js&"
export * from "./ProductStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports